import { useNoveltiesPanel } from '../hooks/useNoveltiesPanel'
import NoveltyClientNotification from './NoveltyClientNotification'
import NoveltiesFeatured from './NoveltiesFeatured'
import NoveltiesLatest from './NoveltiesLatest'

interface NoveltyPanelProps {
  novelties: any[]
}

function NoveltyPanel({ novelties }: NoveltyPanelProps) {
  const { highlightNovelties, noHighlightNovelties, cutContent, handleFavoriteClick } = useNoveltiesPanel(novelties)

  return (
    <>
      <NoveltiesFeatured novelties={highlightNovelties} cutContent={cutContent} />

      <NoveltiesLatest novelties={noHighlightNovelties} cutContent={cutContent} onFavoriteClick={handleFavoriteClick} />

      <NoveltyClientNotification />
    </>
  )
}

export default NoveltyPanel
